import { useUpdate } from '@lilib/hooks';
import { useLocation, useNavigate } from 'react-router-dom';

import useLoadCurrentUser from '../../common/hooks/user/useLoadCurrentUser';

const useRouting = () => {
  // pre-fetch user before loading routes
  const { isLoading, isError, data } = useLoadCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();

  useUpdate(() => {
    if (!data?.currentUser?.hasAcceptedTerms) {
      navigate('/terms', { state: location.pathname });
    }
  }, [data?.currentUser?.hasAcceptedTerms]);

  return {
    showLoading: isLoading,
    showError: isError,
  };
};

export default useRouting;
